import React from "react";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import ContactForm from "../components/ContactForm";
import Footer from "./Footer";
function HomePage() {
  return (
    <div>
      <HeroSection />
      <AboutSection />
      {/* Add more homepage sections here */}
      <ContactForm />
      <Footer />
    </div>
  );
}

export default HomePage;
